import i18next from 'i18next';
import { SupportedLanguage } from 'src/i18n/types';

export const getLanguageDir = () =>
  i18next.dir(i18next.language as SupportedLanguage);
